module.exports = __webpack_public_path__ + "img/coupon.88badbb2.svg";